import { ComponentWithTooltip } from 'components/ComponentWithTooltip';
import type { ConstructionTypeData, ContractResultData } from 'gql/graphql';
import { ContractOtherStatusEnum, ContractOtherConstructionTypeRelationStatusEnum } from 'gql/graphql';
import { getCurrentCostRounding, numberFormatterWithLinePlaceholder } from 'pages/Project/Common/utils';
import { cnMixSpace, IconConnection } from 'uikit';

import type { ICellRendererParams } from 'ag-grid-community';
import type React from 'react';
import { useMemo } from 'react';

import Style from './ConstructionTypeContractPlanCellRenderer.module.css';

interface IConstructionTypeContractPlanCellRenderer extends ICellRendererParams<ContractResultData> {
    costRounding: number;
    constructionType: ConstructionTypeData;
}

export const ConstructionTypeContractPlanCellRenderer: React.FC<IConstructionTypeContractPlanCellRenderer> = (
    props,
) => {
    const { data, costRounding, constructionType } = props;

    const { value, status } = useMemo(() => {
        const currentCostRounding = getCurrentCostRounding(data?.type, costRounding);

        const { contractPlan, status: relationStatus } =
            data?.constructionTypePlanResults?.find((c) => c.constructionTypeId === constructionType.id) || {};

        return {
            value: numberFormatterWithLinePlaceholder({ value: contractPlan }, currentCostRounding),
            status: relationStatus,
        };
    }, [constructionType.id, costRounding, data?.constructionTypePlanResults, data?.type]);

    const isNewRelationStatus = useMemo(
        () =>
            data?.otherCostStatus !== ContractOtherStatusEnum.NewRecord &&
            status === ContractOtherConstructionTypeRelationStatusEnum.NewRecord,
        [data?.otherCostStatus, status],
    );

    return (
        <div className={Style.contractPlan}>
            {isNewRelationStatus && (
                <ComponentWithTooltip tooltipText="Новая связь">
                    <IconConnection size="s" view="link" className={cnMixSpace({ mR: 'xs' })} />
                </ComponentWithTooltip>
            )}
            {value}
        </div>
    );
};

ConstructionTypeContractPlanCellRenderer.displayName = 'ConstructionTypeContractPlanCellRenderer';
